import { Box, Flex, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { logout } from '../../modules/auth/logout'
import { navigationConfig } from './config'
import { Icon } from '../Icon'

export const TopNavigation = () => {
    const router = useRouter()

    const handleLogout = () => {
        logout()
        router.push('/login')
    }

    const handleSupportClick = () => {
        const supportUrl = navigationConfig.bottomItems.find(
            (item) => item.value === 'supportCenter',
        )?.href
        if (supportUrl) {
            window.open(supportUrl, '_blank')
        }
    }

    return (
        <Flex
            position="fixed"
            top={0}
            left={0}
            right={0}
            width="100%"
            height="64px"
            bg="brand.background.primary"
            px={4}
            alignItems="center"
            justifyContent="space-between"
            zIndex={3}
            boxShadow="sm"
        >
            {/* Left side */}
            <Flex alignItems="center" gap={4}>
                <Box width="170px">
                    <Icon type="logo" color="white" width={190} height={20} />
                </Box>
            </Flex>

            {/* Right side */}
            <Flex alignItems="center" gap={2}>
                <Box
                    as="button"
                    px={3}
                    py={2}
                    color="brand.ui.text.inverse"
                    fontSize="sm"
                    fontWeight="medium"
                    _hover={{
                        color: 'brand.status.activeBase',
                    }}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    onClick={handleSupportClick}
                >
                    <Text color="brand.ui.text.inverse">Support</Text>
                </Box>
                <Box
                    as="button"
                    px={3}
                    py={2}
                    color="brand.ui.text.inverse"
                    fontSize="sm"
                    fontWeight="medium"
                    _hover={{
                        color: 'brand.status.activeBase',
                    }}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    onClick={handleLogout}
                >
                    <Text color="brand.ui.text.inverse">Logout</Text>
                </Box>
            </Flex>
        </Flex>
    )
}
